import addressComp from "../address.vue"
import {cpfCnpj, phone} from '../../../filters/string'
import {brToAm} from '../../../filters/date'
import * as obj from './objects'
import Account from '../../../services/account'

export default {
  props: ['account', 'address', 'blockTaxIdNumber'],
  data() {
    return {
      step: 0,
      businessActivity: undefined,
      optanteNacional: false
    }
  },
  mounted(){
      // this.account.accountAuthentication.login = "";
  },

  computed: {
    tel1: {
      get() {
        return this.getCelFormated();
      },
      set(newValue) {
        this.$nextTick(()=>{
          //para o cursor continuar no final do input
          $('#telephone1').val($('#telephone1').val());
        });
        this.setCelFormated(newValue);
      }
    },
    tel2: {
      get() {
        return this.getTel1Formated();
      },
      set(newValue) {
        this.$nextTick(()=>{
          //para o cursor continuar no final do input
          $('#telephone2').val($('#telephone2').val());
        });
        this.setTel1Formated(newValue);
      }
    },
    tel3: {
      get() {
        return this.getTel2Formated();
      },
      set(newValue) {
        this.setTel2Formated(newValue);
      }
    },
    businessActivities(){
      return obj.businessActivity();
    },
    states(){
      return obj.states();
    },

  },

  methods:{
    correctCursor(a){
      if(!window.document.mobile)
        return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },

    getTelType(type) {
      let tels = _.filter(this.account.telephones.telephone, o => o.type == type)
      if (tels && tels.length > 0)
        return tels[0];

      var t = { 'ddd': '', 'numberPhone': '', 'type': type }
      this.account.telephones.telephone.push(t);

      return t;
    },
    getCelFormated(obj) {
      return phone(this.account.dddCellphone + this.account.nroCellphone);
    },
    setCelFormated(value, obj) {
      let t = value.replace(/[^0-9]/g, '');
      this.account.dddCellphone = t.substring(0, 2);
      this.account.nroCellphone = t.substring(2, 11);
    },
    getTel1Formated(obj) {
      return phone(this.account.dddPhone + this.account.nroPhone);
    },
    setTel1Formated(value, obj) {
      let t = value.replace(/[^0-9]/g, '');
      this.account.dddPhone = t.substring(0, 2);
      this.account.nroPhone = t.substring(2, 11);
    },
    getTel2Formated(obj) {
      return phone(this.account.dddPhone2 + this.account.nroPhone2);
    },
    setTel2Formated(value, obj) {
      let t = value.replace(/[^0-9]/g, '');
      this.account.dddPhone2 = t.substring(0, 2);
      this.account.nroPhone2 = t.substring(2, 11);
    },

    validateAll(){
      let vm = this;
      return this.$validator.validateAll()
        .then( r => {
          let firstSpace = vm.account.company.contractManagerFullName.indexOf(" ") || vm.account.company.contractManagerFullName.length;
          vm.account.company.contractManagerName = vm.account.company.contractManagerFullName.substring(0, firstSpace);
          vm.account.company.contractManagerLastName = vm.account.company.contractManagerFullName.substring(firstSpace + 1, vm.account.company.contractManagerFullName.length);
          vm.account.taxIdNumber = vm.account.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
          vm.account.company.optanteNacional = this.getFlagOptanteNacionalFromFront();
          return Account.accountExists({taxIdNumber: vm.account.taxIdNumber}).then(r => {
            if(!r)
              return Promise.reject('Erro');
          });
        }).then( r => {
            return vm.$refs.addressMailing.$validator.validateAll();
        })
    },
    getFlagOptanteNacionalFromFront(){
      if (this.optanteNacional == true){
        return "Y";
      }else{
        return "N";
      }
    },

  },

  components: {addressComp}

}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/company-data.js